import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment as env } from "../../environments/environment";
@Injectable({
  providedIn: "root",
})
export class ApiRequestService {
  apiURL = env.api;

  constructor(private http: HttpClient) {}

  // Send stuffs to API
  sendTransaction(transactionData, auth) {
    const _ = this;
    let headers = new HttpHeaders();
    headers = headers.append(
      'Authorization',
      `Basic ${auth}`
    );

    return _.http.post(_.apiURL + "transaction/create", transactionData, { headers });
  }

  payWithGamecash(params) {
    const _ = this;
    return _.http.post(_.apiURL + "transaction/oxxo_spei", params);
  }

  sendPersonData(personData, auth) {
    const _ = this;
    let headers = new HttpHeaders();
    headers = headers.append(
      'Authorization',
      `Basic ${auth}`
    );
    return _.http.post(_.apiURL + "donor/create", personData, { headers });
  }

  sendInvoiceData(invoiceData) {
    const _ = this;
    return _.http.post(_.apiURL + "donor-address/create", invoiceData);
  }

  getTaxRegimens(invoiceData) {
    const _ = this;
    return _.http.post(_.apiURL + "donor-address/tax-regime", invoiceData);
  }

  sendEmailData(emailData) {
    const _ = this;
    return _.http.post(_.apiURL + "email/send-email", emailData);
  }

  // Get stuffs of API

  getDesign(merchant) {
    let _ = this;
    let conditionsRequest = { conditions: { merchant_id: merchant } };

    return _.http.post(_.apiURL + "design/search", conditionsRequest);
  }

  getPlan(merchant) {
    let _ = this;
    let conditionsRequest = { conditions: {}, merchant: merchant };

    return _.http.post(_.apiURL + "plan/search", conditionsRequest);
  }

  getCampaing(merchant) {
    let _ = this;
    let conditionsRequest = { conditions: {}, merchant: merchant };

    return _.http.post(_.apiURL + "campaign/search", conditionsRequest);
  }

  getZipCode(zipCode, merchant) {
    let _ = this;
    let conditionsRequest = {
      conditions: {
        code: zipCode,
      },
      merchant: merchant,
    };

    return _.http.post(_.apiURL + "postal-code/search", conditionsRequest);
  }

  getCardDetect(cardNumber, merchant) {
    let _ = this;
    let conditionsRequest = {
      conditions: {
        card_number: cardNumber,
      },
      merchant: merchant,
    };

    return _.http.post(_.apiURL + "card/search", conditionsRequest);
  }

  sendPaypalRecurrent(paypalRecurrentData) {
    let _ = this;
    return _.http.post(
      _.apiURL + "transaction/paypal_url",
      paypalRecurrentData
    );
  }

  sendTransactionPaypalRecurrent(paypalRecurrentData) {
    let _ = this;
    return _.http.post(
      _.apiURL + "transaction/paypal_recurrence",
      paypalRecurrentData
    );
  }

  documentType(conditions) {
    let _ = this;
    return _.http.post(_.apiURL + "card/document_type", conditions);
  }
}
